// extracted by mini-css-extract-plugin
export var sliderRange = "_mj-2";
export var sliderRoot = "_mj-0";
export var sliderThumb = "_mj-3";
export var sliderTrack = "_mj-1";